import React, { useCallback } from 'react'
import cx from 'classnames'
import { BtnV2, l } from '@manychat/manyui'

import { billing, UpgradeSource } from 'common/billing'
import { Ability } from 'common/core/constants/Ability'
import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const BlockedByValueMetricNotification = () => {
  useDidMountEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.BLOCKED_BY_VALUE_METRIC.SHOWN')
  })

  const handleRequestUpgradeClick = useCallback(async () => {
    analyticsService.sendEvent('NOTIFICATION_BAR.BLOCKED_BY_VALUE_METRIC.UPGRADE_NOW.CLICKED')
    await billing.requestUpgrade({
      source: UpgradeSource.BLOCKED_BY_VALUE_METRIC,
      abilities: [Ability.ACTIVE_SUBSCRIBERS],
    })
  }, [])

  const handleOpenPlansClick = useCallback(async () => {
    analyticsService.sendEvent('NOTIFICATION_BAR.BLOCKED_BY_VALUE_METRIC.SEE_ALL_PLANS.CLICKED')
    await billing.requestUpgrade({
      source: UpgradeSource.BLOCKED_BY_VALUE_METRIC,
      isManagement: true,
    })
  }, [])

  return (
    <>
      <span>
        {l.translate('Your new contacts aren’t getting automations. You’ve hit your plan limit.')}
      </span>
      <BtnV2 variant="success" onClick={handleRequestUpgradeClick} className="m-l-sm">
        {l.translate('Upgrade now')}
      </BtnV2>
      <span className={cx(cm.readMore, 'm-l-xs')} onClick={handleOpenPlansClick}>
        {l.translate('See all plans')}
      </span>
    </>
  )
}
